import * as React from "react";
import styled from "styled-components";
import Spinner from "react-spinkit";
import { theme } from "../../utils/theme";

export interface LoadingProps {
  color?: string;
  size?: number;
}

const Loading: React.FunctionComponent<LoadingProps> = () => {
  return (
    <Div>
      <Spinner
        name="line-spin-fade-loader"
        color={theme.BLACK_COLOR}
        fadeIn="none"
      />
    </Div>
  );
};

const Div = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export { Loading };
